import { Box, Group } from '@mantine/core';
import cx from 'clsx';
import { FC } from 'react';
import { RadioGroup } from 'src/components/Form/RadioGroup';
import defaultStyles from 'src/components/Form/styles.default.module.css';

import styles from './styles.module.css';

type ThemeOption = {
  image: string;
  label: string;
  value: string;
};

type Props = {
  name: string;
  label: string;
  themeOptions: ThemeOption[];
};

export const ThemeSelector: FC<Props> = ({ name, label, themeOptions }) => {
  return (
    <Box>
      <label className={cx(defaultStyles.label, styles.label)}>{label}</label>
      <Group gap="md" align="flex-start">
        <RadioGroup name={name} data={themeOptions} />
      </Group>
    </Box>
  );
};
